import {
  InfoBlock,
  InfoTitle,
  InfoDescription
} from './styles'

interface props {
  title: string;
  description: any;
}

export function UserInfoBlock({ title, description }: props) {

  return (
    <InfoBlock>
      <InfoTitle>{title}</InfoTitle>
      <InfoDescription>{description}</InfoDescription>
    </InfoBlock>
  )

}